import { IsNotEmpty, IsArray } from 'class-validator';

import { DeadlineFormDto } from './deadline-form.dto';

export class WorkFlowFormDto {
  @IsArray()
  @IsNotEmpty()
  forms: DeadlineFormDto[];
}
